import { Reveal } from "@components/ui";

const moveInItems = [
  "Emirates ID copy",
  "EJARI or Title Deed",
  "Completed application form",
  "Security deposit",
  "Smart meter activation fee",
];

const moveOutItems = [
  "Call or request online",
  "Final meter reading",
  "Settlement of final bill",
  "Refund of security deposit",
];

export function MoveInOutSection() {
  return (
    <section className="w-full bg-[#f1f1f1] overflow-hidden py-10 md:py-14 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col items-center gap-8 md:gap-12 lg:gap-20">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase font-albert-sans">
              Moving Guide
            </span>
            <h2 className="text-[24px] md:text-[40px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
              Move-In / Move-Out Made Easy
            </h2>
            <p className="max-w-[974px] text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#62636c] font-albert-sans leading-[1.4]">
              Simple processes for starting or ending your gas service
            </p>
          </div>
        </Reveal>

        {/* Cards */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* Move-In Card */}
          <Reveal direction="up" className="flex">
            <div className="flex-1 shadow-[0px_4px_24px_rgba(0,0,0,0.1)] rounded-[12px] md:rounded-[16px] bg-white border border-transparent hover:border-[#15803d]/15 hover:shadow-[0_8px_32px_rgba(21,128,61,0.10)] p-6 md:p-12 flex flex-col gap-5 md:gap-6 transition-all duration-300">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-[10px] bg-[#15803d]/10 text-[#15803d] flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path
                      d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="text-[24px] md:text-[32px] lg:text-[40px] tracking-[-0.04em] font-semibold text-[#15803d] font-albert-sans leading-[1.2]">
                  Move-In Requirements
                </h3>
              </div>
              <div className="flex flex-col gap-3 md:gap-4">
                {moveInItems.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-2.5 md:gap-3 p-2.5 md:p-3 rounded-[10px] hover:bg-[#15803d]/[0.04] transition-colors duration-200"
                  >
                    <div className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-[#15803d]/10 flex items-center justify-center shrink-0">
                      <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 md:w-4 md:h-4">
                        <path
                          d="M5 12l5 5L20 7"
                          stroke="#15803d"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Move-Out Card */}
          <Reveal direction="up" delay={100} className="flex">
            <div className="flex-1 shadow-[0px_4px_24px_rgba(0,0,0,0.1)] rounded-[12px] md:rounded-[16px] bg-white border border-transparent hover:border-[#f03813]/15 hover:shadow-[0_8px_32px_rgba(240,56,19,0.10)] p-6 md:p-12 flex flex-col gap-5 md:gap-6 transition-all duration-300">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-[10px] bg-[#f03813]/10 text-[#f03813] flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path
                      d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="text-[24px] md:text-[32px] lg:text-[40px] tracking-[-0.04em] font-semibold text-[#f03813] font-albert-sans leading-[1.2]">
                  Move-Out Requirements
                </h3>
              </div>
              <div className="flex flex-col gap-3 md:gap-4">
                {moveOutItems.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-2.5 md:gap-3 p-2.5 md:p-3 rounded-[10px] hover:bg-[#f03813]/[0.04] transition-colors duration-200"
                  >
                    <div className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-[#f03813]/10 flex items-center justify-center shrink-0">
                      <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 md:w-4 md:h-4">
                        <path
                          d="M9 12l2 2 4-4"
                          stroke="#f03813"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
